var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("common-layout-component2", {
    attrs: { "show-back": "true", "show-admin": "true" },
    on: { "on-nav-back": _vm.back },
    scopedSlots: _vm._u([
      {
        key: "nav-message",
        fn: function() {
          return [_c("p", [_vm._v("タグ登録/編集")])]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "container mainContainer" },
              [
                _c(
                  "div",
                  { staticClass: "columns", attrs: { id: "header-area" } },
                  [
                    _c(
                      "h2",
                      { staticClass: "column", attrs: { id: "title" } },
                      [_vm._v("タグ編集")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "column tr" }, [
                      _c("a", {
                        staticClass: "btn btn-success btn-export",
                        staticStyle: { display: "none" },
                        attrs: { href: "#", type: "button", id: "download" }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "subtitle-area" } }, [
                  _vm._v("タグ一覧")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "columns", attrs: { id: "table-area" } },
                  [
                    _c("div", { staticClass: "column" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button is-login",
                          on: { click: _vm.onClickNew }
                        },
                        [
                          _vm._v("新規登録 "),
                          _c("img", {
                            attrs: {
                              src: "/e-learning/images/ico-plus.png",
                              alt: ""
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button is-login",
                          attrs: { disabled: _vm.editButtonEnabled },
                          on: { click: _vm.onClickEdit }
                        },
                        [
                          _vm._v("編集 "),
                          _c("img", {
                            attrs: {
                              src: "/e-learning/images/ico-pen.png",
                              alt: ""
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button basic is-red",
                          attrs: {
                            disabled: _vm.deleteButtonEnabled,
                            "data-remodal-target": "modal"
                          },
                          on: {
                            click: function($event) {
                              _vm.showModalDelete = true
                            }
                          }
                        },
                        [
                          _vm._v("削除 "),
                          _c("img", {
                            attrs: {
                              src: "/e-learning/images/ico-trash.png",
                              alt: ""
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "column" }, [
                      _c("p", { staticClass: "input-search tr" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button basic is-gray2",
                            attrs: { href: "#" },
                            on: { click: _vm.sortUpdateDatetime }
                          },
                          [
                            _vm._v("更新日順 "),
                            _vm.sortAxis == "update_datetime"
                              ? _c("arrow-up-down-alt", {
                                  attrs: { order: _vm.sortOrder }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "button basic is-gray2",
                            attrs: { href: "#" },
                            on: { click: _vm.sortDictionary }
                          },
                          [
                            _vm._v("名前順 "),
                            _vm.sortAxis == "dictionary"
                              ? _c("arrow-up-down-alt", {
                                  attrs: { order: _vm.sortOrder }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "table-wrapper" }, [
                  _c(
                    "table",
                    { staticClass: "basic scrollTable" },
                    [
                      _c("thead", [
                        _c("tr", [
                          _c("th", {
                            staticStyle: { "max-width": "2em !important" }
                          }),
                          _vm._v(" "),
                          _c("th", [_vm._v("タグ名")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.tags.length == 0,
                              expression: "tags.length == 0"
                            }
                          ]
                        },
                        [
                          _c("td", { attrs: { colspan: "2" } }, [
                            _vm._v("タグが存在しません。")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.tags, function(tag) {
                        return [
                          _c("tr", [
                            _c("td", { staticClass: "check" }, [
                              _c(
                                "label",
                                [
                                  _c("base-check-component", {
                                    on: {
                                      "check-state-change": function($event) {
                                        return _vm.onCheckStateChange(tag)
                                      }
                                    },
                                    model: {
                                      value: tag.selected,
                                      callback: function($$v) {
                                        _vm.$set(tag, "selected", $$v)
                                      },
                                      expression: "tag.selected"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "group-name" }, [
                              _vm._v(_vm._s(tag.tagName))
                            ])
                          ])
                        ]
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _vm.showModalDelete
                  ? _c(
                      "modal-component",
                      {
                        attrs: {
                          "is-delete": true,
                          "is-quest": "true",
                          width: "600"
                        },
                        on: {
                          modalYes: _vm.onClickDelete,
                          modalNo: function($event) {
                            _vm.showModalDelete = false
                          }
                        }
                      },
                      [
                        _c("h4", { attrs: { slot: "header" }, slot: "header" }),
                        _vm._v(" "),
                        _c(
                          "h3",
                          {
                            staticStyle: { "text-align": "center" },
                            attrs: { slot: "body" },
                            slot: "body"
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass: "tc pb2em",
                                staticStyle: { "margin-top": "0.5em" }
                              },
                              [
                                _c("strong", [
                                  _vm._v("選択されたタグを削除しますか？")
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }